'use client';

import { dispatchQuoteModalOpen } from '@/lib/helpers/forms/QuoteFormHelper';
import { Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
import React from 'react';

const DispatchQuoteModalOpenButton = () => {
    const t = useTranslations('shared');

    return (
        <div onClick={() => dispatchQuoteModalOpen()} className="block mt-8 underline underline-offset-4 cursor-pointer">
            <Typography variant="body1" className='text-white'>{t('dispatch_quote_modal_open_button')} →</Typography>
        </div>
    );
}

export default DispatchQuoteModalOpenButton;